import { useIntl } from '@capsicum/common';
import { Alert, Text } from '@capsicum/common-web';
import { AlertIcon } from '@capsicum/common-web/icons';
import { type CSSProperties, type ReactNode } from 'react';
import styled from 'styled-components';

import { useNCWalletActionBarNavigation } from '../../hooks/useNCWalletActionBarNavigation';

export const NCWInsufficientChzAlert = ({ style, ...props }: { style?: CSSProperties }) => {
	const { $t } = useIntl();
	const { navigationCallbacks: routeTo } = useNCWalletActionBarNavigation();

	return (
		<S.Wrapper style={style} {...props}>
			<Alert
				closable={false}
				icon={AlertIcon}
				testID="ncwSend-confirmation-insufficientChz-alert"
				title={$t('marketplace.alerts.noChilizForSellingNetworkFeeTitle')}
				type="warning"
			>
				<Text color="main.enabled" variant="text4">
					{$t<JSX.Element>('ncWallet.send.insufficientChzAlert.description', {
						receiveLink: (chunks: Array<ReactNode>) => (
							<S.Link
								data-testid="ncwSend-confirmation-insufficientChz-receive-link"
								onClick={routeTo['receive']}
							>
								{chunks}
							</S.Link>
						),
						topupLink: (chunks: Array<ReactNode>) => (
							<S.Link
								data-testid="ncwSend-confirmation-insufficientChz-topup-link"
								onClick={routeTo['topup']}
							>
								{chunks}
							</S.Link>
						)
					})}
				</Text>
			</Alert>
		</S.Wrapper>
	);
};

namespace S {
	export const Wrapper = styled.div``;

	export const Link = styled.a`
		${({ theme }) => theme.fonts.text.text4};
		color: ${({ theme }) => theme.colors.text.brand.enabled};
		text-decoration: none;
	`;
}
